<template>
	<div>
		<b-row>
			<b-col md="12" class="mb-4">
				<h6>Null</h6>
				<parameter-selectbox v-model="value1" sort="code" code="days"/>
				<span>{{ value1 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Single Selected</h6>
				<parameter-selectbox v-model="value2" sort="code" code="days"/>
				<span>{{ value2 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Multiple Selected</h6>
				<parameter-selectbox v-model="value3" sort="code" code="days" :multiple="true"/>
				<span>{{ value3 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Validate Error</h6>
				<parameter-selectbox v-model="value4" sort="code" code="days" :validate-error="value4ValidateError"/>
				<span>{{ value4 }}</span>
			</b-col>
			<b-col cols="12">
				<b-button variant="primary" @click="change()">
					{{ $t('change').toUpper() }}
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";

	export default {
		components: {
			ParameterSelectbox,
		},
		data() {
			return {
				value1: null,
				value2: 1,
				value3: ['1', '2'],
				value4: 1,
				value4ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.value2 = 2
				this.value3 = ['3', '4', '5', '6']
				this.value4 = 2
				this.value4ValidateError = 'Error'
			}
		}
	};
</script>

